import {
    BrowserRouter as Router,
    Routes,
    Route,
} from 'react-router-dom';
import GlobalLoader from '../components/global-loader';
import Activation from '../pages/auth/activation';
import AuthCheck from '../pages/auth/check';
import Login from '../pages/auth/login';
import Registration from '../pages/auth/registration';
import InfoPage from '../pages/info';
import Layout from '../pages/layout';

function AppRouter() {
    return (
        <>
            <GlobalLoader />
            <Router>
                <Routes>
                    <Route path="/" element={<AuthCheck />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/registration" element={<Registration />} />
                    <Route path="/registration/activation" element={<Activation />} />
                    <Route path="/info" element={<InfoPage />} />
                    <Route path="/:objectName" element={<Layout />} />
                    <Route path="/:objectName/:pageType" element={<Layout />} />
                    <Route path="/:objectName/:pageType/:objectId" element={<Layout />} />
                </Routes>
            </Router>
        </>
    );
}

export default AppRouter;
